export default Object.freeze({
    PLATFORM: 'V',
    FAMILY: 'A',
    CUSTOMER: 'C',
});
